import { isAdminEmail } from './adminUsers.js';

export const DEV_DARK_STORAGE_KEY = 'extracta-dev-dark-mode';
export const DEV_DARK_MODE_EVENT = 'extracta-dev-dark-mode';

const notifyDevDarkModeChange = () => {
  window.dispatchEvent(new Event(DEV_DARK_MODE_EVENT));
};

export const isStoredDevDarkModeEnabled = () => {
  try {
    return localStorage.getItem(DEV_DARK_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const isDevDarkModeEnabled = () =>
  document.documentElement.classList.contains('dev-dark');

export const applyDevDarkMode = (enabled, email) => {
  if (!isAdminEmail(email)) {
    clearDevDarkMode();
    return;
  }

  document.documentElement.classList.toggle('dev-dark', enabled);
  localStorage.setItem(DEV_DARK_STORAGE_KEY, String(enabled));
  notifyDevDarkModeChange();
};

export const clearDevDarkMode = () => {
  document.documentElement.classList.remove('dev-dark');
  notifyDevDarkModeChange();
};

export const initDevDarkMode = (email) => {
  if (!isAdminEmail(email)) {
    clearDevDarkMode();
    return;
  }

  applyDevDarkMode(isStoredDevDarkModeEnabled(), email);
};

export const toggleDevDarkMode = (email) => {
  if (!isAdminEmail(email)) {
    return isDevDarkModeEnabled();
  }

  const next = !isDevDarkModeEnabled();
  applyDevDarkMode(next, email);
  return next;
};
